import { render, staticRenderFns } from "./traffictviolation.vue?vue&type=template&id=718a29d8"
import script from "./traffictviolation.vue?vue&type=script&lang=js"
export * from "./traffictviolation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports